export const API_URL_V1 = '/api/v1/'